//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  SECONDARY_BTN_GK,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONTS
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useState, useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import BannerAbout from "../../components/BannerAbout";
import { IoCameraOutline } from "react-icons/io5";
import LogoFuneralDistancia from "../../assets/images/logo-funeral-distancia.png";
import FuneralDistanciaImg from "../../assets/images/funeral-distancia.webp";
import Obituary from "../../components/Obituary";
import { HiOutlineVideoCamera } from "react-icons/hi";
import FooterBar from "../../components/FooterBar";
import Funeral from "../../assets/images/funeral.webp";
import "./FuneralDistancia.css";

export default function FuneralDistancia() {
  const [inputValue, setInputValue] = useState("");
  const [inputError, setInputError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleClick = () => {
    if (inputValue === process.env.REACT_APP_ROOM_CER_PASS) {
      window
        .open(
          "http://admin:admin12345@201.20.153.50:83/cgi-bin/mjpg/video.cgi?channel=1&subtype=1&cmd=playsound&-tone=custom&-times=1",
          "_blank",
        )
        .focus();
      setInputError("");
    } else if (inputValue === process.env.REACT_APP_ROOM_A_PASS) {
      window
        .open(
          "http://201.20.153.50:81/cgi-bin/mjpg/video.cgi?channel=1&subtype=1",
          "_blank",
        )
        .focus();
      setInputError("");
    } else if (inputValue === process.env.REACT_APP_ROOM_B_PASS) {
      window
        .open(
          "http://201.20.153.50:82/cgi-bin/mjpg/video.cgi?channel=1&subtype=1",
          "_blank",
        )
        .focus();
      setInputError("");
    } else {
      setInputError(
        <p style={{ fontSize: SUB_TEXT_SIZE }} className="funeral-input-error">
          senha incorreta
        </p>,
      );
    }
  };

  return (
    <div>
      <DynamicTitle
        pageTitle="Grupo Krause - Funeral a Distância"
        pageMeta="Grupo Krause"
        pageContent="Valorizando a vida com serviços que respeitam o ser humano. Grupo Krause é formado por quatro marcas que oferecem serviços funerários no RS."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <IoCameraOutline
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"FUNERAL A DISTÂNCIA"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={
          "Acompanhe despedidas virtualmente de qualquer lugar do mundo."
        }
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={FuneralDistanciaImg}
        bannerBGmobile={FuneralDistanciaImg}
      />
      <BannerAbout
        companyBrand={LogoFuneralDistancia}
        brandHeight={130}
        firstText={`A gente sabe que a perda de um ente querido é um momento difícil para toda a família. Além de toda a dor, nem sempre é possível reunir amigos e parentes distantes. Foi por essa razão que criamos o serviço de Funeral a distância, para que a despedida de seu ente querido possa ser acompanhada virtualmente de qualquer lugar do mundo.`}
        secondText={""}
        textColor={TEXT_COLOR}
        textSize={TEXT_SIZE}
      />
      <Container>
        <Row>
          <Col className="funeral-distancia-col">
            <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
              <HiOutlineVideoCamera
                style={{ color: ICON_COLOR_GK }}
                className="funeral-distancia-icon"
              />
              ACESSO AO AMBIENTE RESTRITO
            </h2>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="funeral-distancia-second-col">
            <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
              Digite a senha informada pela equipe do Grupo Krause para acessar
              a sala de velório correspondente
            </p>
            <input
              type="text"
              id="key"
              name="chave"
              value={inputValue}
              onChange={handleChange}
              className="funeral-distancia-input"
              style={{ fontSize: TEXT_SIZE, color: TEXT_COLOR }}
              placeholder="Digite a senha de acesso"
              autoComplete="off"
            />
            {inputError}
            <button
              style={{
                color: WHITE,
                fontSize: TEXT_SIZE,
                background: PRIMARY_BTN_GK,
              }}
              onClick={handleClick}
              className="primary-btn-funeral"
            >
              ACESSAR SALA
            </button>
          </Col>
          <Col lg={{ span: 6, order: "first" }} className="about-second-col">
            <div className="about-img-container">
              <img src={Funeral} alt="Família" />
              <div className="about-img-overlay" />
            </div>
          </Col>
        </Row>
      </Container>
      <Obituary
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        secondaryBtnColor={SECONDARY_BTN_GK}
        primaryBtnColor={PRIMARY_BTN_GK}
        funeralDistanciaCall={false}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
